@if (isPlatformBrowser(platformId)) {
  <nouislider (change)="handleChange($event)" (ngModelChange)="rangeChange.emit($event)"
              [ngModel]="range()"
              [config]="config"/>
}
